import './ShareProjectRemoveModal.scss';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'src/modules/common/components/Button';
import { ModalBody } from 'src/modules/common/components/ModalBody';
import { ModalFooter } from 'src/modules/common/components/ModalFooter';
import { ModalHeader } from 'src/modules/common/components/ModalHeader';
import { Project } from 'src/modules/common/types/Project';
import { SharedUser } from 'src/modules/sharing-projects/types/SharedUser';

type Props = {
  readonly project: Project;
  readonly user: SharedUser;
  readonly submitting: boolean;

  readonly onConfirm: () => void;
  readonly onCancel: () => void;
};

export const ShareProjectRemoveModal = ({
  project,
  user,
  submitting,
  onConfirm,
  onCancel,
}: Props): React.ReactElement => {
  const intl = useIntl();

  return (
    <>
      <ModalHeader
        title={<FormattedMessage id="shareProject/removeModal/title"/>}
        handleClose={onCancel}
        danger={true}
      />

      <ModalBody danger={true}>
        <div className="bp-share-project-remove-modal__body">
          <FormattedMessage
            id="shareProject/removeModal/body"
            values={{
              firstName: user.firstName,
              lastName: user.lastName,
              projectName: project.data.title,
            }}
          />
        </div>
      </ModalBody>

      <ModalFooter>
        <Button
          kind="secondary"
          onClick={onCancel}
          autoFocus={true}
          fullWidth={true}
          disabled={submitting}
        >
          <FormattedMessage id="shareProject/removeModal/action/cancel"/>
        </Button>

        <Button
          disabled={submitting}
          kind="danger"
          onClick={onConfirm}
          fullWidth={true}
          loading={submitting}
        >
          <FormattedMessage id="shareProject/removeModal/action/remove"/>
        </Button>
      </ModalFooter>
    </>
  );
};
